import { Environment } from 'models/environment';
import { StartDateAdjustmentDetails } from 'policies/domain/start-date-adjustments';
import { apiRequest, EmbedAuth, getApiHost, getBasePathname } from 'shared/api';

interface Params {
  policyId: string;
  organizationId: string;
  environment: Environment;
  auth: EmbedAuth;
  newStartDate: string;
  newBillingDay: number | undefined;
  newBillingMonth: number | undefined;
}

export const getPolicyStartDatePreview = async (params: Params) => {
  const { auth, organizationId, policyId, environment, newStartDate, newBillingDay, newBillingMonth } = params;

  const basePathName = getBasePathname({
    organizationId,
    auth,
    clientAppAuth: true,
  });

  const queryParams = new URLSearchParams({ new_start_date: newStartDate });
  if (newBillingDay !== undefined) {
    queryParams.set('new_billing_day', String(newBillingDay));
  }
  if (newBillingMonth !== undefined) {
    queryParams.set('new_billing_month', String(newBillingMonth));
  }

  const response = await apiRequest({
    url: `${getApiHost({ environment })}${basePathName}/policies/${policyId}/start-date-preview?${queryParams.toString()}`,
    method: 'get',
    auth,
  });

  const json = await response.json();
  return StartDateAdjustmentDetails.fromJSON(json.data);
};
